import { useState, useEffect } from 'react';
import { Route, Switch, NavLink } from 'react-router-dom';
import cn from "classnames";
import { request } from '../lib/apiRequestWrapper';
import LoadingSpinner from '../components/LoadingSpinner';
import Enquiry from './Enquiry';
import Reservation from './Reservation';
import { MAINTENANCE } from '../constants';
import { connect } from 'react-redux';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
const stripePromise = loadStripe(process.env.RAZZLE_STRIPE_PUBLIC_KEY);

const mapStateToProps = state => {
  return {
    postData: state.data.postData,
  }
}

const FormWrapper = ({ postData, theme }) => {

  const [vehicleId, setVehicleId] = useState(postData?.id || false);
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [hasFetchedData, setHasFetchedData] = useState(false);
  const [fetchError, setFetchError] = useState(false);
  const [vehicleImage, setVehicleImage] = useState("");
  const [vehicleEdmImage, setVehicleEdmImage] = useState("");
  const [vehicleData, setVehicleData] = useState("");
  const [isReserved, setIsReserved] = useState(false);
  const [isSold, setIsSold] = useState(false);
  const [isUsed, setIsUsed] = useState(false);

  const getImages = (vin, pictures, type) => {
    // get edm image
    request(
      `${process.env.RAZZLE_MEDIASERVICE}/MediaServiceCache/vinimageurl`,
      {
        method: "POST",
        body: JSON.stringify({vin: vin, view: "n3c01auw", mimeType: "image/jpg", width: 1200})
      }
    ).then((res) => {
      setVehicleEdmImage({url: res.imageUrl});
    }).catch((error) => {
      //
    });
    var image = {};
    if (pictures?.length > 0) {
      image = pictures.find(image => {
        return image.key === "vtp4x3m2c";
      });
      if (!image?.url) {
        image = pictures[0];
        // at the time of this update (Oct 2025) this image for new cars is tiny and needs to be replaced with another fallback
      }
    }
    if (image?.url) {
      setVehicleImage(image);
    }
    if (!image?.url || (image?.key !== "vtp4x3m2c" && type !== "U")) {
      // we either have no image or a tiny one, load a fallback image
      request(
        `${process.env.RAZZLE_MEDIASERVICE}/MediaServiceCache/vinimageurl`,
        {
          method: "POST",
          body: JSON.stringify({vin: vin, view: "n3c01aut", mimeType: "image/png", width: 1000})
        }
      ).then((res) => {
        setVehicleImage({url: res.imageUrl});
      }).catch((error) => {
        //
      });
    }
  };

  const checkAvailability = (commissionNumber) => {
    request(
      `${process.env.RAZZLE_MYAUDI_API}/1/vtp/isreserved/${commissionNumber}`
    ).then(() => {
      setIsFetchingData(false);
      setHasFetchedData(true);
    }).catch(error => {
      if (error.status === 409) {
        // car is already reserved or sold
        if (error.body && error.body.message && error.body.message === "Sold") {
          setIsSold(true);
        } else {
          setIsReserved(true);
        }
      }
      if (/*error.status === 400 || */error.status === 500) {
        setFetchError(true);
      }
      setIsFetchingData(false);
      setHasFetchedData(true);
    });
  }

  useEffect(() => {
    setTimeout(() => {window.scrollTo(0, 0);}, 50);

    if (postData?.id) {
      setIsFetchingData(true);
      setHasFetchedData(false);
      if (postData.type === "U") {
        setIsUsed(true);
      }
      let pics = postData.pictures || [];
      if (postData.tilesPictures) {
        pics = pics.concat(postData.tilesPictures);
      }
      getImages(postData.vin, pics, postData.type);
      checkAvailability(postData.commissionNumber);
    } else if (vehicleId) {
      // no postData
      let strippedVehicleId = vehicleId.replace(/[^a-z0-9]/gi, '');
      if (strippedVehicleId.indexOf("AA") === 0) {
        setIsFetchingData(true);
        setHasFetchedData(false);
        request(
          `${process.env.RAZZLE_API}/1/service/vehicle/${strippedVehicleId}`
        ).then((data) => {
          // console.log(data);
          if (data.vehicle?.basic?.type === "U") {
            setIsUsed(true);
          }
          var pictures = data.vehicle?.detail.pictures || data.vehicle?.basic.pictures;
          getImages(data.vehicle?.basic?.vin, pictures, data.vehicle?.basic?.type);
          checkAvailability(data.vehicle?.basic?.commissionNumber);
          setVehicleData(data.vehicle?.basic);
        }).catch((error) => {
          setIsFetchingData(false);
          setFetchError(true);
        });
      }
    }
  }, [vehicleId]);

  let isReservable = false;
  if (hasFetchedData && !isReserved) {
    if (isUsed && !MAINTENANCE.reservationUsed) { isReservable = true; }
    if (!isUsed && !MAINTENANCE.reservationNew) { isReservable = true; }
  }

  return(
    <div className="">
      <div className={cn("vehicle-hero aui-color-gray95", vehicleImage.key || "")}>
        {isFetchingData && !vehicleImage && <LoadingSpinner type="placeholder" />}
        {vehicleImage?.url && <div role="img" className="vehicle-hero__img" style={{
          backgroundImage: `url("${vehicleImage.url}")`,
        }} />}
      </div>

      <nav className="form-tabs aui-color-gray95 pt-3">
        <NavLink to={`/enquiry?vehicleid=${vehicleId}`} activeClassName="active">Make an enquiry</NavLink>
        {isReservable && <NavLink to={`/reservation?vehicleid=${vehicleId}`} activeClassName="active">Order your Audi</NavLink>}
      </nav>
      <div className={cn("aui-color-white p-2 position-relative", {"aui-color-black": theme === "dark", "aui-color-white": theme === "light"})} />

      <Switch>
        <Route exact path="/enquiry"
          render={(routeProps) =>
            <Enquiry {...routeProps}
              setVehicleId={setVehicleId}
              isFetchingData={isFetchingData}
              setFetchError={setFetchError}
              fetchError={fetchError}
              vehicleId={postData?.id ? postData.id : vehicleId}
              vehicleImage={vehicleImage}
              vehicleEdmImage={vehicleEdmImage}
              vehicleData={postData?.id ? postData : vehicleData}
              isUsed={isUsed}
              theme={theme}
              />} />
        <Route exact path="/reservation"
          render={(routeProps) => {
            return (
              <Elements stripe={stripePromise}>
                <Reservation {...routeProps}
                  setVehicleId={setVehicleId}
                  vehicleId={postData?.id ? postData.id : vehicleId}
                  isFetchingData={isFetchingData}
                  setFetchError={setFetchError}
                  fetchError={fetchError}
                  vehicleImage={vehicleImage}
                  vehicleEdmImage={vehicleEdmImage}
                  vehicleData={postData?.id ? postData : vehicleData}
                  isReserved={isReserved}
                  isSold={isSold}
                  isUsed={isUsed}
                  theme={theme}
                />
              </Elements>
            );
          }}
        />
        <Route path="*" render={({ staticContext }) => {
          if (staticContext) { staticContext.status = 404; }
          return <div>404 Not Found</div>
        }} />
      </Switch>
    </div>
  )
};

export default connect(mapStateToProps)(FormWrapper);
